// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/mutation-upsert-subscriber-stages.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Subscribers(
  $delete_stage_ids: [uuid!]!
  $user_id: uuid!
  $insert_objects: [tasks_subscribers_insert_input!]!
) {
  delete_tasks_subscribers(
    where: { user_id: { _eq: $user_id }, stage_id: { _in: $delete_stage_ids } }
  ) {
    affected_rows
  }

  insert_tasks_subscribers(objects: $insert_objects) {
    returning {
      id
    }
  }
}

`